const settings = {

	baseUrl: null,
	baseImagePath: null,
	manufactorLogoPath: null,
	server: null,
	stage: null,
	clientBaseUrl: null,
	defaultTitle: "BoOve AB  - delar och tillbehör till mc och cykel" ,
	defaultTitlePrefix: "BoOve AB - ",
	productListMaxAge: 60 * 58 * 2, // 2 timmar-ish
	baseModelMaxAge: 60 * 60 * 1, // 1h

}


export default settings;